import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Mapper } from './Mapper';
import { useCallback, useContext, useEffect } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { NoResults2 } from 'Components';
import { AddCommaToNumber } from 'Utils/AddCommaToNumber';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const Results = () => {
  const { suppliers, dispatchSuppliers, filters } =
    useContext(SuppliersContext);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .textResult;

  const initFilteredSuppliers = useCallback(() => {
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Therapy,
      payload: { value: filters },
    });
  }, []);

  useEffect(() => {
    initFilteredSuppliers();
  }, [initFilteredSuppliers]);

  return (
    <Stack>
      {suppliers.filteredResults.length > 0 ? (
        <Typography
          variant='body2'
          aria-live='polite'
          aria-atomic='true'
          component='h2'
        >
          {`${dictionary.found} ${AddCommaToNumber(
            suppliers.filteredResults.length
          )} ${dictionary.results}`}
        </Typography>
      ) : (
        <NoResults2
          textSearch={dictionary.noResult}
          textSx={{ width: isDesktop ? undefined : '175px' }}
        />
      )}
      <Mapper />
    </Stack>
  );
};
